import { render, staticRenderFns } from "./copyMaterialForcast.vue?vue&type=template&id=0f7e24bf&"
import script from "./copyMaterialForcast.vue?vue&type=script&lang=js&"
export * from "./copyMaterialForcast.vue?vue&type=script&lang=js&"
import style0 from "./copyMaterialForcast.vue?vue&type=style&index=0&id=0f7e24bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports